<template>
    <div>
        <!-- Sidebar -->
        <div class="pe-3" style="min-height: 100vh;">
            <div class="p-3">
                <MasonryWall :items="chunkedNodes" :gap="16" :column-width="280" :columns="{ default: 6, 1200: 3, 768: 2, 576: 1 }">
                    <template #default="{item}">
                        <div class="border p-2 mb-4" v-for="node in item" :key="node.id">
                            <TextSidebarTreeNode :contentTree="$root.contentTree" :node="node" is-container/>
                        </div>
                    </template>
                </MasonryWall>
            </div>
        </div>
        <!-- Main Content Area -->
        <div>
            <div v-for="(nodes, idx) in chunkedNodes" :key="idx">
                <div class="row">
                    <div class="col-12 p-2" v-for="node in nodes" :key="node.id">
                        <div v-if="node.activeTitle" class="m-2">
                            <div class="p-3">
                                <TextTreeNode :contentTree="$root.contentTree" :node="node" is-container/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
</template>

<script>
import MasonryWall from '@yeger/vue-masonry-wall'
import TextSidebarTreeNode from '../navigator/TextSidebarTreeNode.vue';
import TextTreeNode from '../navigator/TextTreeNode.vue';
export default {
    name: "ClassicCodeView",
    components: {
        MasonryWall,
        TextTreeNode,
        TextSidebarTreeNode
    },
    props: {
        chunkedNodes: {
            type: Array,
            required: true
        }
    }
}
</script>